import { createFileRoute } from "@tanstack/react-router";

import { FeedbackPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/feedback")({
  component: FeedbackPage,
});
